import tokens from '@datacamp/waffles-tokens';
import { css } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var dotStyle = /*#__PURE__*/css({
  backgroundColor: tokens.colors.red,
  border: "1px solid ".concat(tokens.colors.white),
  borderRadius: 8,
  height: 8,
  position: 'absolute',
  width: 8,
  zIndex: tokens.zIndex.default
}, process.env.NODE_ENV === "production" ? "" : ";label:dotStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Vc2VyQWNjb3VudE1lbnUvQWxlcnREb3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdpQiIsImZpbGUiOiIuLi8uLi9zcmMvVXNlckFjY291bnRNZW51L0FsZXJ0RG90LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0b2tlbnMgZnJvbSAnQGRhdGFjYW1wL3dhZmZsZXMtdG9rZW5zJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuY29uc3QgZG90U3R5bGUgPSBjc3Moe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRva2Vucy5jb2xvcnMucmVkLFxuICBib3JkZXI6IGAxcHggc29saWQgJHt0b2tlbnMuY29sb3JzLndoaXRlfWAsXG4gIGJvcmRlclJhZGl1czogOCxcbiAgaGVpZ2h0OiA4LFxuICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgd2lkdGg6IDgsXG4gIHpJbmRleDogdG9rZW5zLnpJbmRleC5kZWZhdWx0LFxufSk7XG5cbnR5cGUgQWxlcnREb3QgPSB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn07XG5cbmZ1bmN0aW9uIEFsZXJ0RG90KHsgY2xhc3NOYW1lIH06IEFsZXJ0RG90KTogSlNYLkVsZW1lbnQge1xuICByZXR1cm4gKFxuICAgIDxzcGFuXG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIGNzcz17ZG90U3R5bGV9XG4gICAgICBkYXRhLXRlc3RpZD1cInVzZXItYWNjb3VudC1tZW51LWFsZXJ0LWRvdFwiXG4gICAgLz5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgQWxlcnREb3Q7XG4iXX0= */");

function AlertDot(_ref) {
  var className = _ref.className;
  return ___EmotionJSX("span", {
    className: className,
    css: dotStyle,
    "data-testid": "user-account-menu-alert-dot"
  });
}

export default AlertDot;